// export const seconds2Duration = (seconds: number) => {
//   const hour = Math.floor(seconds / 3600) >= 10 ? Math.floor(seconds / 3600) : Math.floor(seconds / 3600);
//   seconds -= 3600 * hour;
//   const min = Math.floor(seconds / 60) >= 10 ? Math.floor(seconds / 60) : Math.floor(seconds / 60);
//   seconds -= 60 * min;

//   return checkAppendZero(hour) + ":" + checkAppendZero(min) + ":" + checkAppendZero(seconds);
// };

// const checkAppendZero = (num: number) => {
//   return num < 10 ? "0" + num : num;
// };

export const seconds2Duration = (_seconds: number) => {
  // 处理浮点数精度问题，确保秒数是整数
  const seconds = Math.round(_seconds);

  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const remainingSeconds = seconds % 60;

  // 格式化为两位数
  const hoursFormatted = String(hours).padStart(2, "0");
  const minutesFormatted = String(minutes).padStart(2, "0");
  const secondsFormatted = String(remainingSeconds).padStart(2, "0");

  return `${hoursFormatted}:${minutesFormatted}:${secondsFormatted}`;
};
